module.exports = __webpack_public_path__ + "img/pressalit_4.bbbc8ce9.jpg";